import executeRecaptchaInvisible from '@/google-recaptcha/executeRecaptchaInvisible';
import executeYandexCaptchaInvisible from '@/yandex-captcha/executeCaptchaInvisible';
import { CAPTCHA_TYPE_YANDEX, CAPTCHA_TYPE_GOOGLE } from '@/constants';

/**
 * @description
 * Получает данные капчи и её статус.
 * Если капча невидимая, то запускает её выполнение и возвращает статус 'pending'. Когда капча будет выполнена, вызовется callback-функция для отправки формы.
 * Если капча обычная, то проверяет наличие токена и возвращает статус 'success' или 'missing'.
 * @param {Object} options - параметры для получения данных капчи
 * @param {HTMLElement} options.form - форма, в которой находится капча
 * @param {string} options.captchaType - тип капчи ('yandex', 'google')
 * @param {HTMLElement} options.fieldRecaptcha - поле Google reCAPTCHA
 * @param {HTMLElement} options.fieldYandexCaptcha - поле Yandex Captcha
 * @param {string|null} options.formType - тип формы (например, 'feedback', 'comment', 'review'). Используется для создания скрытого поля с токеном капчи с атрибутом name в котором указан тип формы, например, name="${formType}[g-recaptcha-response]".
 * @param {Function} options.callback - функция обратного вызова, которая будет вызвана при выполнении капчи
 *
 * @returns {Object} - объект с данными капчи и её статусом
 * @property {Object} messageData - данные сообщения, которые будут отправлены на сервер
 * @property {string} messageData.status - статус капчи ('success', 'pending', 'missing')
 * @property {string|null} messageData.captchaType - тип капчи ('yandex', 'google', null)
 * @property {HTMLElement} messageData.fieldRecaptcha - поле Google reCAPTCHA, если оно есть
 * @property {HTMLElement} messageData.fieldYandexCaptcha - поле Yandex Captcha, если оно есть
 * @property {string|null} messageData.formType - тип формы, если он указан
 */
export default ({
  form,
  captchaType,
  fieldRecaptcha,
  fieldYandexCaptcha,
  formType = null,
  callback
}) => {
  const result = {
    messageData: {},
    // 'success', 'pending', 'missing'
    status: '',
    // 'yandex', 'google', null
    captchaType: null,
    fieldRecaptcha,
    fieldYandexCaptcha,
    formType
  };

  if (captchaType === CAPTCHA_TYPE_YANDEX && fieldYandexCaptcha) {
    result.captchaType = CAPTCHA_TYPE_YANDEX;

    if (fieldYandexCaptcha.dataset.yandexCaptchaType === 'invisible') {
      const token = executeYandexCaptchaInvisible(form, callback);

      if (token) {
        result.messageData['yandex-smart-token'] = token;
        result.status = 'success';

        return result;
      }

      result.status = 'pending';
      // eslint-disable-next-line no-console
      console.log('Ожидание выполнения Yandex Captcha Invisible...');

      return result;
    }

    // Обычная видимая капча
    const tokenInput = fieldYandexCaptcha.querySelector('[name="yandex-smart-token"]');
    const tokenValue = tokenInput ? tokenInput.value : '';

    result.messageData['yandex-smart-token'] = tokenValue;
    result.status = tokenValue ? 'success' : 'missing';

    return result;
  }

  if (captchaType === CAPTCHA_TYPE_GOOGLE && fieldRecaptcha) {
    result.captchaType = CAPTCHA_TYPE_GOOGLE;

    if (fieldRecaptcha.dataset.recaptchaType === 'invisible') {
      const recaptchaValue = executeRecaptchaInvisible(form, callback, formType);

      if (recaptchaValue) {
        result.messageData['g-recaptcha-response'] = recaptchaValue;
        result.messageData.recaptcha_type = 'invisible';
        result.status = 'success';

        return result;
      }

      result.status = 'pending';
      // eslint-disable-next-line no-console
      console.log('Ожидание выполнения Google reCAPTCHA Invisible...');

      return result;
    }

    // Обычная видимая капча
    const tokenInput = fieldRecaptcha.querySelector('[name="g-recaptcha-response"]');
    const tokenValue = tokenInput ? tokenInput.value : '';

    result.messageData['g-recaptcha-response'] = tokenValue;
    result.status = tokenValue ? 'success' : 'missing';

    return result;
  }

  // Капча не настроена или не найдена
  return result;
};
